import React from 'react'
import { observer } from 'mobx-react'
import { formatToLongDate } from 'utils/date-util'
import { formatMoney } from 'utils/money-util'
import { formatVisibility } from '../../formatters/amendments-card-formatters'
import AmendmentsTableViewModel from './AmendmentsTableViewModel'
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from 'components/Table/ClickableTable'
import Pill from 'components/Pill'
import styles from './AmendmentsTable.sass'
import cx from 'classnames'

interface Props {
  vm: AmendmentsTableViewModel
}

export default observer(function AmendmentsTable({ vm }: Props) {
  const { currentSort, currentSortOrder, setSort } = vm

  return (
    <div className={styles.tableContainer}>
      <Table stickyHeader>
        <TableHead>
          {vm.columns.map((col) => (
            <TableHeader
              key={col.key}
              canSort={col.sortable}
              sortOrder={col.key === currentSort ? currentSortOrder : 'none'}
              onSort={(newSort) => setSort(col.key, newSort)}
            >
              <div className={styles.tableHeader}>{col.header}</div>
            </TableHeader>
          ))}
        </TableHead>
        <TableBody>
          {vm.orderedAmendments.map((amendment, i) => {
            const isCustomerAmountNegative = amendment.customer_amount < 0
            const isProviderAmountNegative = amendment.provider_amount < 0

            return (
              <TableRow key={i}>
                <TableCell>
                  <div className={styles.description}>
                    {amendment.description}
                  </div>
                  <div className={styles.internalNote}>
                    {amendment.internal_note}
                  </div>
                </TableCell>
                <TableCell>
                  <Pill>{formatVisibility(amendment.visibility)}</Pill>
                </TableCell>
                <TableCell
                  className={cx(
                    styles.amount,
                    isCustomerAmountNegative && styles.negativeAmount,
                  )}
                >
                  {formatMoney(amendment.customer_amount)}
                </TableCell>
                <TableCell
                  className={cx(
                    styles.amount,
                    isProviderAmountNegative && styles.negativeAmount,
                  )}
                >
                  {formatMoney(amendment.provider_amount)}
                </TableCell>
                <TableCell className={styles.date}>
                  {formatToLongDate(amendment.date_created)}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </div>
  )
})
